import { useState, useEffect } from 'react';
import Navigation from './Navigation';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const targetDate = new Date('2026-04-15T23:59:59');
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="relative min-h-screen w-full">
      <h1 className="sr-only">ItsJustTax - US Tax Forms, Guides & Calculators</h1>
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/9f09b61827a8b2d2ba5749490753ba68.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <Navigation scrolled={scrolled} />

      <div className="relative z-10 flex items-center min-h-screen">
        <div className="w-full max-w-7xl mx-auto px-6 lg:px-8 py-20">
          <div className="grid lg:grid-cols-5 gap-12 items-center">
            <div className="lg:col-span-3">
              <h1 className="text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" style={{ lineHeight: '1.2' }}>
                Navigate US Tax Season with Confidence
              </h1>
              <p className="text-xl text-white/90 mb-10 max-w-2xl leading-relaxed">
                Expert guidance, powerful tools, and real-time updates for individuals and small businesses
              </p>
              <div className="flex flex-wrap gap-4">
                <a 
                  href="#calculators"
                  className="px-8 py-4 bg-white text-gray-900 rounded-full font-semibold hover:bg-gray-100 transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap"
                >
                  Explore Tax Tools
                </a>
                <a 
                  href="#blog"
                  className="px-8 py-4 bg-transparent text-white border-2 border-white rounded-full font-semibold hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Read Latest Guides
                </a>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="bg-white rounded-3xl p-8 shadow-2xl">
                <h3 className="text-2xl font-bold text-gray-900 mb-6">2026 Tax Filing Deadline</h3>
                <div className="grid grid-cols-4 gap-4 mb-6">
                  <div className="text-center">
                    <div className="text-4xl font-bold text-teal-600">{timeLeft.days}</div>
                    <div className="text-sm text-gray-600 mt-1">Days</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-teal-600">{timeLeft.hours}</div>
                    <div className="text-sm text-gray-600 mt-1">Hours</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-teal-600">{timeLeft.minutes}</div>
                    <div className="text-sm text-gray-600 mt-1">Minutes</div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold text-teal-600">{timeLeft.seconds}</div>
                    <div className="text-sm text-gray-600 mt-1">Seconds</div>
                  </div>
                </div>
                <div className="space-y-3">
                  <a 
                    href="#forms"
                    className="block w-full px-4 py-3 bg-teal-50 text-teal-700 rounded-full text-center font-medium hover:bg-teal-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Form 1040 Guide
                  </a>
                  <a 
                    href="#state-resources"
                    className="block w-full px-4 py-3 bg-teal-50 text-teal-700 rounded-full text-center font-medium hover:bg-teal-100 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    State Tax Resources
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}